// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0","loaderContainer":"Loader_loaderContainer__UDDYf"};